import React from 'react'
import { Route, Switch } from 'react-router-dom'

// No Route
import NoRoute from './NoRoute'

import B2bAccounts from './B2bAccounts'
import B2bUsersIndex from './B2bUsersIndex'
import BuserEdit from './BuserEdit'
import CouponRedirect from './CouponRedirect'
import CouponsIndex from './CouponsIndex'
import Forgot from './Forgot'
import Login from './Login'
import PasswordCreated from './PasswordCreated'
import ProfileEdit from './ProfileEdit'
import ResetPassword from './ResetPassword'
import SetPassword from './SetPassword'
import TestsIndex from './TestsIndex'
import UserConfirm from './UserConfirm'
import UserRedirect from './UserRedirect'
import VoucherNew from './VoucherNew'
import VouchersIndex from './VouchersIndex'
import Frame from './Frame'

class RouteProvider extends React.Component {
  componentWillMount() {
    if (this.props.loggedOn) {
      document.body.style.backgroundColor = "#f1f1f1"
    } else {
      document.body.style.background = "none"
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.loggedOn !== prevProps.loggedOn) {
      if (this.props.loggedOn) {
        document.body.style.backgroundColor = "#f1f1f1"
      } else {
        document.body.style.background = "none"
      }
    }
  }

  render() {
    const {mainComp} = this.props

    return (
        <Switch>
          <Route exact path="/" component={mainComp} />
          <Route exact path="/frame" component={Frame} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/reset_password" component={Forgot} />
          <Route exact path="/new_password/:reset_password_token" component={ResetPassword} />
          <Route exact path="/set_password/:reset_password_token" component={SetPassword} />
          <Route exact path="/profile/edit" component={ProfileEdit} />
          <Route exact path="/pass" component={PasswordCreated} />
          <Route exact path="/accounts" component={B2bAccounts} />
          <Route exact path="/coupons" component={CouponsIndex} />
          <Route exact path="/tests" component={TestsIndex} />
          <Route exact path="/tests/coupon" component={CouponRedirect} />
          <Route exact path="/tests/user" component={UserRedirect} />
          <Route exact path="/tests/test" component={UserRedirect} />
          <Route exact path="/activate/:token" component={UserConfirm} />
          <Route exact path="/tests" component={TestsIndex} />
          <Route exact path="/vouchers/new" component={VoucherNew} />
          <Route exact path="/vouchers" component={VouchersIndex} />
          <Route exact path="/managers" component={B2bAccounts} />
          <Route exact path="/users" component={B2bUsersIndex} />
          <Route exact path="/users/:buser_id/edit" component={BuserEdit} />

          <Route path="*" component={NoRoute} />

        </Switch>
    )
  }
}

export default RouteProvider



// WEBPACK FOOTER //
// ./src/js/components/RouteProvider.js